import React, { useEffect, useRef } from 'react';
import abcjs from 'abcjs';
import 'abcjs/abcjs-audio.css';

export default function AbcPreview({ abc, width = 300, scale = 0.9, maxBars = 2 }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!abc || !containerRef.current) return;

    const lines = abc
      .split('\n')
      .filter(line => !line.startsWith('T:')) // Remove title line
      .filter(line => !line.startsWith('X:')) // Remove index line
      .filter(line => !line.startsWith('Z:')); // Remove composer line

    const header = lines.filter(line => /^[A-Z]:/.test(line) && !line.startsWith('K:')).join('\n');
    const keyLine = lines.find(line => line.startsWith('K:')) || 'K:C';
    const musicLines = lines.filter(line => !/^[A-Z]:/.test(line));

const rawBars = musicLines.join(' ').split('|');
const slicedBars = rawBars.slice(0, maxBars + 2); // capture a few bars

// Clean only inside each bar
const cleanedBars = slicedBars.map(bar =>
  bar
    .replace(/\(3/g, '')         // remove triplets
    .replace(/[\(\)]/g, '')      // remove slurs
    .replace(/\{.*?\}/g, '')     // remove grace notes
    .replace(/\+.*?\+/g, '')     // remove ornaments
    .replace(/"[^"]*"/g, '')     // remove text annotations
);

const sliced = cleanedBars.join('|');

const meterLine = lines.find(line => line.startsWith('M:')) || 'M:4/4';
const lengthLine = lines.find(line => line.startsWith('L:')) || 'L:1/8';

const previewAbc = `X:1\n${meterLine}\n${lengthLine}\n${keyLine}\n|${sliced}|`;

abcjs.renderAbc(containerRef.current, previewAbc, {
  staffwidth: width,
  scale: 0.55,
  paddingtop: 0,
  paddingbottom: 0,
  paddingright: 0,
  paddingleft: 0,
  selectionColor: 'none',
  centerVertically: true,
  add_classes: false,
});


  }, [abc, width, scale, maxBars]);

  return <div ref={containerRef} />;
}
